import React from 'react'

import { wave } from '@ui-kit/components/Wave/styles'
import { COLOR } from '@ui-kit/constants'

import { SHAPES } from './shapes'
import type { Props } from './types'

const Wave = (props: Props) => {
  const className = wave({
    flipX: props.flipX,
    flipY: props.flipY,
  })
  return (
    <svg
      viewBox={`0 0 375 ${SHAPES[props.shape].height}`}
      preserveAspectRatio="none"
      className={className}
    >
      <path d={SHAPES[props.shape].path} fill={COLOR[props.color]} />
    </svg>
  )
}

export default Wave
